import { useMemo } from 'react';
import { useQueryState, useQuery } from '@ywwwtseng/react-kit';
import { getBalanceTotal } from '@/utils/token';
import type { SelectToken, SelectUserBalance } from '@/types';

export function useUserBalanceTotal() {
  const tokens = useQueryState<SelectToken[]>('tokens');

  const { data: balances } =
    useQuery<SelectUserBalance[]>('user_balances');

  return useMemo(() => {
    if (!tokens || !balances) {
      return {
        value: 0,
        formatted: '0',
      };
    }
    return getBalanceTotal(tokens, balances);
  }, [tokens, balances]);
}
